import React from "react";
import { Instagram } from "lucide-react";
import { BTS, SITE } from "../mock";

const BehindTheScenes = () => {
  return (
    <section className="py-24 md:py-32 bg-[#f5efe6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 reveal">
          <div>
            <p className="kicker mb-5">Behind The Scenes</p>
            <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
              What it's actually <span className="italic font-light">like on the day</span>
            </h2>
          </div>
          <a href={SITE.social.instagram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-3 text-[#1f1d1a] hover:text-[#8b6f47] transition-colors">
            <Instagram size={20} />
            <span className="text-[0.72rem] tracking-[0.3em] uppercase">@VowAndVideoEssex</span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {BTS.map((b, i) => (
            <a
              key={i}
              href={SITE.social.instagram}
              target="_blank"
              rel="noreferrer"
              className={`group block overflow-hidden reveal ${i === 0 ? "md:col-span-2 md:row-span-2 aspect-square" : "aspect-square"}`}
            >
              <div className="relative w-full h-full overflow-hidden">
                <img src={b.img} alt={b.caption} className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-110" />
                <div className="absolute inset-0 bg-[#1f1d1a]/0 group-hover:bg-[#1f1d1a]/40 transition-all duration-500 flex items-end p-5">
                  <p className="text-[#f5efe6] text-xs font-light opacity-0 group-hover:opacity-100 transition-opacity duration-500 leading-relaxed">
                    {b.caption}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BehindTheScenes;
